module.exports = __webpack_public_path__ + "static/media/resetlock.16c084f1.svg";